import { memo } from 'react';
import ListItem from '../List-Item/ListItem';

export interface ListProps {
  data?: any[] | undefined;
}

function List({ data }: ListProps) {
  return (
    <div>
      {data?.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>
          <ul>
            <ListItem {...item} />
          </ul>
        </div>
      ))}
    </div>
  );
}

export default memo(List);
